import { ImageGroup, TransformConfig } from '../types';

// Converts API response to ImageGroup[] format
export const transformResponse = (
  responseData: any,
  config: TransformConfig
): ImageGroup[] => {
  if (!responseData) {
    return [];
  }

  const groups: ImageGroup[] = [];
  const skipFields = config.skipFields || ['proId'];
  const defaultLabel = config.defaultLabel || 'Others';

  // Process specified fields or all array fields
  const fieldsToProcess = config.fields.length > 0 
    ? config.fields.filter(field => responseData[field] && Array.isArray(responseData[field]))
    : Object.keys(responseData).filter(key => 
        !skipFields.includes(key) && Array.isArray(responseData[key])
      );

  fieldsToProcess.forEach((key) => {
    const images = responseData[key];
    if (!images || images.length === 0) {
      return;
    }

    const label = config.labelMappings[key] || defaultLabel;

    groups.push({
      key: key.toLowerCase(),
      label: label,
      images: images.map((url: string, index: number) => ({
        id: `${key}-${index}`,
        url: url,
        type: label,
        category: key.toLowerCase(),
        fileName: `${label}-${index + 1}`
      }))
    });
  });

  return groups;
};
